import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { catalogImportPlugin } from '@backstage/plugin-catalog-import';
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';
import { RequirePermission } from '@backstage/plugin-permission-react';

export const catalogImportModule = createFrontendModule({
  pluginId: 'catalog-import',
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/catalog-import',
        noHeader: true,
        routeRef: catalogImportPlugin.routes.importPage,
        loader: () =>
          import('@backstage/plugin-catalog-import').then(m => (
            <RequirePermission permission={catalogEntityCreatePermission}>
              <m.DefaultImportPage />
            </RequirePermission>
          )),
      },
    }),
  ],
});
